import React, { useState } from 'react';
import './App.css';
import { ToSForm } from './ToSForm';
import { SuccessScreen } from './Success';

function App() {
  const [submitted, setSubmitted] = useState(false);
  const { pathname } = window.location;
  const path = pathname?.replace('/', '');
  const accepted = path === 'accepted';
  const isToSForm = path?.length === 26;

  if (!isToSForm && !accepted && !submitted) {
    window.location.href = 'https://chainvalley.pro/tou';
    return null;
  }

  const handleAccept = () => {
    window.location.pathname = 'accepted';
    setSubmitted(true);
  }

  return (
    <div className="app">
      {!submitted && isToSForm && <ToSForm linkToken={path} onSubmitSuccess={handleAccept} />}
      {(submitted || accepted) && <SuccessScreen />}
    </div>
  );
}

export default App;
